import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, ref, onMounted, getCurrentInstance, watch, h, computed, onBeforeUnmount, nextTick } from "vue";
import { DownCircleOutlined, FilterFilled } from "@ant-design/icons-vue";
import { genFileId } from "element-plus";
import SvgIcon from "../components/SvgIcon.vue";
import util from "@/util/util";
import ExDialog from "../components/ExDialog.vue";
import { useRouter, useRoute } from "vue-router";
import permission from "@/util/permission";
import { useI18n } from "vue-i18n";
import { debounce } from 'lodash-es';
import { defaultConfig } from "ant-design-vue/es/theme/internal";

import { ElNotification, ElMessageBox, ElMessage, ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/loading/style/css';
export default defineComponent({
  name: "DataInformation",
  components: {
    SvgIcon,
    ExDialog,
    DownCircleOutlined,
    FilterFilled
  },
  setup() {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    var storeCurrentRow = null;
    const storeLoading1 = ref(false);
    const storeForm1 = ref(null);
    const storeTypeNum1 = ref(null);
    const activityIdNum1 = ref(null);
    const uploadFilePopoverVisible = ref(false);
    const arrValue = ref([]);
    const storeData1 = reactive({
      importMessageVisible: false,
      importMessages: [],
      data: [],
      paginationData: {
        pageSizes: [25, 50, 100],
        currentPage: 1,
        totalSize: 0,
        pageSize: 25
      },
      storePageRO: {
        searchKeyword: null,
        format: null,
        storeTypeIds: [],
        // storeTypeId: null,
        activityIds: [],
        city: null,
        checkAll: false,
        activityCheckAll: false,
        indeterminate: false,
        activityIndeterminate: false,
        provinceCity: null
      },
      storeTypeData: [],
      storeTypeProps: {
        label: "storeTypeNameZh",
        value: "storeTypeId"
      },
      storeStatusData: [],
      storeStatusColorData: ["#738BFF",
      // 蓝紫（提亮）
      "#FEBD30",
      // 金黄
      "#29C93F",
      // 亮绿
      "#FF6057",
      // 红
      "#A23DFF",
      // 亮紫
      "#21B97A" // 青绿
      ],

      storeStatusProps: {
        label: "storeStatusNameZh",
        value: "storeStatusId"
      },
      storeForm1Data: {
        storeName: null,
        storeCode: null,
        storeAddress: null,
        storeTypeId: null,
        city: null,
        contactName: null,
        contactMobile: null,
        contactEmail: null,
        storeStatusId: null
      },
      provinceDictData: [],
      formatDictData: [],
      storeForm1Rules: {
        storeName: [{
          required: true,
          message: t('storeManage.storeNameRequired'),
          trigger: "blur"
        }],
        storeCode: [{
          required: true,
          message: t('storeManage.storeCodeRequired'),
          trigger: "blur"
        }],
        storeAddress: [{
          required: true,
          message: t('storeManage.storeAddressRequired'),
          trigger: "blur"
        }],
        storeTypeId: [{
          required: true,
          message: t('storeManage.storeTypeRequired'),
          trigger: "blur"
        }],
        city: [{
          required: true,
          message: t('storeManage.cityRequired'),
          trigger: "blur"
        }],
        contactName: [{
          required: true,
          message: t('storeManage.contactPersonRequired'),
          trigger: "blur"
        }],
        contactMobile: [{
          required: true,
          message: t('storeManage.contactNumberRequired'),
          trigger: "blur"
        }],
        contactEmail: [{
          required: true,
          message: t('storeManage.emailRequired'),
          trigger: "blur"
        }],
        storeStatusId: [{
          required: true,
          message: t('storeManage.storeStatusRequired'),
          trigger: "blur"
        }]
      },
      storeUpdateVisible: false,
      selectedStoreTypes: [],
      selectedActivityIds: [],
      storeLocationConditionList: {},
      StoreLocationConditionCheck: {
        storeTypeName: true,
        storeTypeNameIndeterminate: false,
        storeTypeNameInput: '',
        supportType: true,
        supportTypeIndeterminate: false,
        supportTypeInput: '',
        aec: true,
        aecIndeterminate: false,
        aecInput: '',
        gender: true,
        genderIndeterminate: false,
        genderInput: '',
        category: true,
        categoryIndeterminate: false,
        categoryInput: '',
        region: true,
        regionIndeterminate: false,
        regionInput: '',
        location: true,
        locationIndeterminate: false,
        locationInput: '',
        locationSummary: true,
        locationSummaryIndeterminate: false,
        locationSummaryInput: ''
      },
      StoreLocationConditionRO: [{
        conditionType: 'ice',
        condition: []
      }, {
        conditionType: 'category',
        condition: []
      }, {
        conditionType: 'citys',
        condition: []
      }, {
        conditionType: 'storeTypeName',
        condition: []
      }, {
        conditionType: 'gender',
        condition: []
      }, {
        conditionType: 'location',
        condition: []
      }, {
        conditionType: 'locationSummary',
        condition: []
      }, {
        conditionType: 'region',
        condition: []
      }, {
        conditionType: 'supportType',
        condition: []
      }]
    });
    const openUploadFilePopover = () => {
      uploadFile.value.clearFiles();
      uploadFilePopoverVisible.value = true;
    };
    const activityData1 = reactive([]);
    const getStoreType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreLocationCondition = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationCondition(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getAllStoreLocation = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getAllStoreLocation(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreByPageRequest = async (index, pageSize, storePageRO) => {
      storeLoading1.value = true;
      //传空数组后台报错，在这里判断下改成null
      // let copyData = JSON.parse(JSON.stringify(storePageRO));
      // if (copyData.storeTypeIds.length === 0) {
      //   copyData.storeTypeIds = null;
      // }
      let storePageROPageInfo = {
        pageSize: pageSize,
        pageIndex: index,
        data: storePageRO
      };
      proxy.$api.storeRequest.getAllStoreLocation(storePageROPageInfo).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202104") {
            let storeList = res.result.data.pageList;
            storeList.forEach(element => {
              element.citys = element.city;
            });
            storeData1.data.length = 0;
            storeData1.data.push(...storeList);

            // if (Array.isArray(storeList)) {
            //   for (let store of storeList) {
            //     if (store.activityName) {
            //       store.activityNames = store.activityName.split(",");
            //     }
            //     storeData1.data.push(store);
            //   }
            // }
            storeData1.paginationData.totalSize = res.result.data.totalCount;
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
        storeLoading1.value = false;
      }).catch(error => {
        if (error.code != "TOKEN_MISSING") {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
        storeLoading1.value = false;
      });
    };
    const getStoreByPageRequestPush = async (index, pageSize, storePageRO) => {
      storeLoading1.value = true;
      //传空数组后台报错，在这里判断下改成null
      // let copyData = JSON.parse(JSON.stringify(storePageRO));
      // if (copyData.storeTypeIds.length === 0) {
      //   copyData.storeTypeIds = null;
      // }
      let storePageROPageInfo = {
        pageSize: pageSize,
        pageIndex: index,
        data: storePageRO
      };
      proxy.$api.storeRequest.getAllStoreLocation(storePageROPageInfo).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202104") {
            let storeList = res.result.data.pageList;
            if (Array.isArray(storeList)) {
              for (let store of storeList) {
                if (store.activityName) {
                  store.activityNames = store.activityName.split(",");
                }
                store.citys = store.city;
                storeData1.data.push(store);
              }
            }
            storeData1.paginationData.totalSize = res.result.data.totalCount;
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
        storeLoading1.value = false;
      }).catch(error => {
        if (error.code != "TOKEN_MISSING") {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
        storeLoading1.value = false;
      });
    };
    watch(() => storeData1.storePageRO.storeTypeIds, newVal => {
      storeData1.selectedStoreTypes.length = 0;
      newVal.forEach(id => {
        const storeType = storeData1.storeTypeData.find(item => item.storeTypeId === id);
        if (storeType) {
          storeData1.selectedStoreTypes.push({
            value: storeType.storeTypeId,
            label: storeType.storeTypeNameZh
          });
        }
      });
    });
    watch(() => storeData1.selectedStoreTypes, newVal => {
      if (newVal.length === 0) {
        onClear();
      }
    });
    const onClear = () => {
      storeData1.storePageRO.storeTypeIds.length = 0;
      searchStoreClick1();
    };
    watch(() => storeData1.storePageRO.activityIds, newVal => {
      storeData1.selectedActivityIds.length = 0;
      newVal.forEach(id => {
        const activity = activityData1.find(item => item.activityId === id);
        if (activity) {
          storeData1.selectedActivityIds.push({
            value: activity.activityId,
            label: activity.activityName
          });
        }
      });
    });
    watch(() => storeData1.selectedActivityIds, newVal => {
      if (newVal.length === 0) {
        onActivityClear();
      }
    });
    const onActivityClear = () => {
      storeData1.storePageRO.activityIds.length = 0;
      searchStoreClick1();
    };

    // 1. 定义 ref
    const tableBoxRef = ref(null); // 表格外层容器的引用
    const tableScrollY = ref(400); // 表格内容区域的高度（y轴）

    // 2. 计算高度的函数
    const calcTableHeight = () => {
      nextTick(() => {
        if (tableBoxRef.value) {
          // 获取容器高度
          const containerHeight = tableBoxRef.value.offsetHeight;

          // 获取表头高度 (Ant Design Vue 的表头类名通常是 .ant-table-thead)
          // 注意：这里需要确保 DOM 渲染完成，所以用了 nextTick
          const header = tableBoxRef.value.querySelector('.ant-table-thead');
          const headerHeight = header ? header.offsetHeight : 0;

          // 计算内容高度 = 容器高度 - 表头高度
          // 减去 1 或 2px 是为了防止出现双滚动条（边框误差）
          tableScrollY.value = containerHeight - headerHeight - 2;
        }
      });
    };
    const convertToCascaderFormat = async cityList => {
      // 按省份分组
      const groupedByProvince = {};
      cityList.forEach(item => {
        const province = item.text.province;
        if (!groupedByProvince[province]) {
          groupedByProvince[province] = [];
        }
        groupedByProvince[province].push({
          label: item.text.city,
          value: item.value.city
        });
      });

      // 构建级联数据格式
      const result = Object.keys(groupedByProvince).map(province => {
        return {
          label: province,
          value: province,
          children: groupedByProvince[province]
        };
      });
      return result;
    };
    onMounted(async () => {
      // 初始化计算
      calcTableHeight();
      // 监听窗口大小变化，实现响应式
      window.addEventListener('resize', calcTableHeight);
      let storeTypeList = await getStoreType();
      if (storeTypeList == null) {
        return;
      } else {
        storeTypeList.forEach(element => {
          storeData1.storeTypeData.push(element.storeTypeNameZh);
          storeData1.StoreLocationConditionRO[3].condition.push(element.storeTypeNameZh);
        });
      }
      let storeLocationConditionList = await getStoreLocationCondition();
      if (storeLocationConditionList == null) {
        return;
      }
      let formattedData = Object.keys(storeLocationConditionList).reduce((acc, key) => {
        if (key == 'citys') {
          const value = storeLocationConditionList[key];
          if (Array.isArray(value)) {
            acc[key] = value.map(item => ({
              text: item,
              value: item
            }));
          } else {
            acc[key] = value;
          }
        } else {
          const value = storeLocationConditionList[key];
          // 处理其他键：保持原键名，值保持为原数组（如果本身就是数组）
          if (Array.isArray(value)) {
            acc[key] = value; // 核心修改：将值赋给 acc 的当前 key，而不是直接替换 acc
          } else {
            // 如果原值不是数组，按你的需求可以赋值为空数组，或者保留原值（视你的业务逻辑而定）
            acc[key] = [];
          }
        }
        return acc;
      }, {});
      let cityArr = await convertToCascaderFormat(formattedData.citys);
      formattedData.cityArr = cityArr;
      storeData1.storeLocationConditionList = formattedData;
      // cityArr.forEach(province => {
      //   const provinceValue = province.value;
      //   // 遍历该省份下的城市
      //   if (province.children && province.children.length > 0) {
      //     province.children.forEach(city => {
      //       // 在多选级联中，每一项是一个路径数组 [省份, 城市]
      //       arrValue.value.push([provinceValue, city.value]);
      //     });
      //   }
      // })
      console.log(formattedData);
      storeData1.StoreLocationConditionRO[8].condition = formattedData.supportType;
      storeData1.StoreLocationConditionRO[0].condition = formattedData.aec;
      storeData1.StoreLocationConditionRO[4].condition = formattedData.gender;
      storeData1.StoreLocationConditionRO[1].condition = formattedData.category;
      storeData1.StoreLocationConditionRO[7].condition = formattedData.region;
      storeData1.StoreLocationConditionRO[5].condition = formattedData.location;
      storeData1.StoreLocationConditionRO[6].condition = formattedData.locationSummary;
      getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
      if (storeTable1.value) {
        const scrollWrapper = storeTable1.value.$el.querySelector('.ant-table-body');
        if (scrollWrapper) {
          scrollWrapper.addEventListener('scroll', handleScroll1);
        }
      }
      initColumns();
    });
    onBeforeUnmount(() => {
      // 移除监听，防止内存泄漏
      window.removeEventListener('resize', calcTableHeight);
    });
    const headerCellClickEvent1 = ({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter
    }) => {
      const $table = storeTable1.value;
      if ($table) {
        // 如果触发了列的其他功能按钮
        if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
          if (column.order === "desc") {
            $table.clearSort();
          } else if (column.order === "asc") {
            $table.sort(column.field, "desc");
          } else {
            $table.sort(column.field, "asc");
          }
        }
      }
    };
    const storeClickEvent1 = row => {
      window.open(`/store-location/${row.storeCode}/0`, "_blank");
    };
    const storeTable1 = ref(null);
    const uploadStore1Location1 = ref(null);
    const uploadStore1Location1PopoverVisible = ref(false);
    const uploadStore1Location1Data = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openuploadStore1Location1Popover1 = () => {
      uploadStore1Location1.value.clearFiles();
      uploadStore1Location1PopoverVisible.value = true;
    };
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          // console.log(error);
          reject(error);
        });
      });
    };
    const handleStoreLocationBeforeUpload1 = async file => {
      uploadStore1Location1Data.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadStore1Location1Data.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadStore1Location1Data.signatureData.dir + fullName;
      uploadStore1Location1Data.data = {
        name: file.name,
        key: keyValue,
        policy: uploadStore1Location1Data.signatureData.policy,
        OSSAccessKeyId: uploadStore1Location1Data.signatureData.accessId,
        signature: uploadStore1Location1Data.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadStore1Location1Data.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleStoreLocationExceed1 = files => {
      uploadStore1Location1.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadStore1Location1.value.handleStart(file);
      uploadStore1Location1.value.submit();
    };
    const handleStoreLocationOnSuccess1 = async (response, file, files) => {
      if (file.status === "success") {
        let uploadedRO = {
          fileName: uploadStore1Location1Data.data.name,
          uploadedName: uploadStore1Location1Data.data.key
        };
        importStoreLocationRequest(uploadedRO);
      }
    };
    const importStoreLocationRequest = async uploadedRO => {
      proxy.$api.storeRequest.importStoreLocation(uploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202103") {
            uploadStore1Location1PopoverVisible.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else if (res.result.dataCode === "202170") {
            uploadStore1Location1PopoverVisible.value = false;
            storeData1.importMessageVisible = true;
            storeData1.importMessages = res.result.data;
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    /////

    const uploadStore1 = ref(null);
    const uploadStore1PopoverVisible = ref(false);
    const uploadStore1Data1 = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openuploadStore1Popover1 = () => {
      uploadStore1.value.clearFiles();
      uploadStore1PopoverVisible.value = true;
    };
    const handleStoreBeforeUpload1 = async file => {
      uploadStore1Data1.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadStore1Data1.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadStore1Data1.signatureData.dir + fullName;
      uploadStore1Data1.data = {
        name: file.name,
        key: keyValue,
        policy: uploadStore1Data1.signatureData.policy,
        OSSAccessKeyId: uploadStore1Data1.signatureData.accessId,
        signature: uploadStore1Data1.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadStore1Data1.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleStoreExceed1 = files => {
      uploadStore1.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadStore1.value.handleStart(file);
      uploadStore1.value.submit();
    };
    const handleStoreOnSuccess1 = async (response, file, files) => {
      if (file.status === "success") {
        let uploadedRO = {
          fileName: uploadStore1Data1.data.name,
          uploadedName: uploadStore1Data1.data.key
        };
        importStoreRequest(uploadedRO);
      }
    };
    const importStoreRequest = async uploadedRO => {
      proxy.$api.storeRequest.importStore(uploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202111") {
            uploadStore1PopoverVisible.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else if (res.result.dataCode === "202177") {
            uploadStore1PopoverVisible.value = false;
            storeData1.importMessageVisible = true;
            storeData1.importMessages = res.result.data;
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const searchStoreClick1 = async () => {
      let scrollWrapper = storeTable1.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData1.paginationData.currentPage = 1;
      getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.storePageRO);
    };
    const cancelSaveStore1 = () => {
      storeForm1.value.resetFields();
      storeData1.storeUpdateVisible = false;
    };
    const storeUpdateClick1 = row => {
      util.propertyClone(row, storeData1.storeForm1Data);
      storeData1.storeUpdateVisible = true;
      storeCurrentRow = row;
    };
    const deleteStoreRequest = async storeDeleteRO => {
      proxy.$api.storeRequest.deleteStore(storeDeleteRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202112") {
            util.removeArrayById("storeId", storeData1.data, storeCurrentRow.storeId);
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const storeDeleteClick1 = row => {
      ElMessageBox.confirm(t('storeManage.confirmDelete') + row.storeName, t('storeManage.ask'), {
        confirmButtonText: t('storeManage.confirm'),
        cancelButtonText: t('storeManage.cancel'),
        type: "warning"
      }).then(() => {
        storeCurrentRow = row;
        var storeDeleteRO = {
          storeCode: row.storeCode
        };
        deleteStoreRequest(storeDeleteRO);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t('storeManage.cancel')
        });
      });
    };
    const goLocation1 = row => {
      window.open(`/store-location/${row.storeCode}/0`, "_blank");
    };
    const handleScroll1 = () => {
      checkScrollBottom1();
    };
    const checkScrollBottom1 = debounce(async () => {
      // console.log('滚动')
      if (!storeTable1.value) return;

      // 1. 修正选择器：适配 Ant Design Vue
      const scrollWrapper = storeTable1.value.$el.querySelector('.ant-table-body');
      if (!scrollWrapper) return;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = scrollWrapper;
      const isBottom = scrollHeight - scrollTop <= clientHeight + 70;

      // console.log(isBottom)

      if (isBottom && !storeLoading1.value) {
        // console.log('isBottom');

        // console.log(storeData1.paginationData.totalSize)
        let num = Math.ceil(storeData1.paginationData.totalSize / storeData1.paginationData.pageSize); // ✅

        if (num === storeData1.paginationData.currentPage) {
          // console.log('bottom');
          return;
        }
        storeData1.paginationData.currentPage += 1;
        getStoreByPageRequestPush(storeData1.paginationData.currentPage, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
      }
    }, 300);
    const handleFileBeforeUpload = async file => {
      // console.log(file)
      uploadFileData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadFileData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadFileData.signatureData.dir + fullName;
      uploadFileData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadFileData.signatureData.policy,
        OSSAccessKeyId: uploadFileData.signatureData.accessId,
        signature: uploadFileData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadFileData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleFileOnSuccess = async (response, file, files) => {
      // console.log(file.status)
      if (file.status === "success") {
        // console.log('success')
        let activityUploadedRO = {
          uploadedRO: {
            fileName: uploadFileData.data.name,
            uploadedName: uploadFileData.data.key
          }
        };
        uploadFileRequest(activityUploadedRO);
      }
    };
    const uploadFileData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadFile = ref(null);
    const columns = ref([]);
    const cityFilters = ref([]);
    const getFilteredValue = arr => {
      let res = [];
      arr.forEach(element => {
        res.push(element.value);
      });
      return res;
    };
    const initColumns = () => {
      columns.value = [{
        title: t('storeManage.storeName'),
        dataIndex: 'storeName',
        ellipsis: true,
        width: 300
      }, {
        title: 'Door Concept',
        dataIndex: 'storeTypeNameZh',
        filters: storeData1.storeTypeData,
        customFilterDropdown: true,
        ellipsis: true,
        width: 200
      }, {
        title: '城市',
        dataIndex: 'citys',
        ellipsis: true
      }, {
        title: '支持类型',
        dataIndex: 'supportType',
        ellipsis: true,
        customFilterDropdown: true,
        width: 150
      }, {
        title: 'ACE',
        dataIndex: 'ice',
        ellipsis: true,
        customFilterDropdown: true,
        width: 100
      }, {
        title: '性别',
        dataIndex: 'gender',
        ellipsis: true,
        customFilterDropdown: true,
        width: 100
      }, {
        title: 'Category',
        dataIndex: 'category',
        ellipsis: true,
        customFilterDropdown: true
      }, {
        title: '区域',
        dataIndex: 'region',
        ellipsis: true,
        customFilterDropdown: true
      }, {
        title: '位置',
        dataIndex: 'location',
        ellipsis: true,
        customFilterDropdown: true
      }, {
        title: '位置描述',
        dataIndex: 'locationSummary',
        ellipsis: true,
        customFilterDropdown: true
      }];
    };
    const convertFilters = inputFilters => {
      return Object.keys(inputFilters).map(key => ({
        conditionType: key,
        condition: inputFilters[key]
      }));
    };
    const handleTableChange = (pagination, filters, sorter, extra) => {
      console.log('筛选变化:', filters);
      let newData = convertFilters(filters);
      console.log(newData);
      newData.forEach(newItem => {
        if (newItem.conditionType == "storeTypeNameZh") {
          newItem.conditionType = 'storeTypeName';
        }
        if (newItem.condition != null) {
          const existingItem = storeData1.StoreLocationConditionRO.find(item => item.conditionType === newItem.conditionType);
          if (existingItem) {
            existingItem.condition = [...newItem.condition]; // 使用扩展运算符复制数组
          }
        } else {
          const existingItem = storeData1.StoreLocationConditionRO.find(item => item.conditionType === newItem.conditionType);
          if (existingItem) {
            existingItem.condition = []; // 使用扩展运算符复制数组
          }
        }
      });

      console.log(storeData1.StoreLocationConditionRO);
      storeData1.paginationData.currentPage = 1;
      console.log(storeData1.StoreLocationConditionRO);
      getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
    };
    const getAllStoreLocationExport = async () => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      let storePageROPageInfo = {
        pageSize: 1,
        pageIndex: 25,
        data: storeData1.StoreLocationConditionRO
      };
      proxy.$api.storeRequest.getAllStoreLocationExport(storePageROPageInfo).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const arrUtil = async arr => {
      let retArr = [];
      for (let x in arr) {
        if (arr[x].length === 1) {
          for (let i = 0; i < arr[x][0].children.length; i++) {
            retArr.push(arr[x][0].children[i].value);
          }
        }
        if (arr[x].length === 2) {
          retArr.push(arr[x][1].value);
        }
      }
      return retArr;
    };
    const cityArrChange = async (value, selectedOptions) => {
      let res = await arrUtil(selectedOptions);
      console.log(res);
      if (res.length == 0) {
        const index = storeData1.StoreLocationConditionRO.findIndex(item => item.conditionType === 'citys');
        storeData1.StoreLocationConditionRO[index].condition = [];
        getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
      } else {
        const index = storeData1.StoreLocationConditionRO.findIndex(item => item.conditionType === 'citys');
        if (index !== -1) {
          storeData1.StoreLocationConditionRO[index].condition = res;
        } else {
          storeData1.StoreLocationConditionRO.push({
            conditionType: 'citys',
            condition: res
          });
        }
        storeData1.paginationData.currentPage = 1;
        getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
      }
    };
    const cascaderRef = ref(null);
    const handleIconClick = async () => {
      console.log("Cascader Ref:", cascaderRef.value);
      if (cascaderRef.value) {
        // 等待 DOM 更新完成
        await nextTick();

        // 尝试获取 Cascader 内部的输入框元素
        const inputElement = cascaderRef.value.$el.querySelector('input');
        console.log("Input Element:", inputElement);
        if (inputElement) {
          // 先聚焦再点击，这通常能触发下拉菜单
          inputElement.focus();
          inputElement.click();
        } else {
          // 如果找不到 input，尝试聚焦整个组件容器
          console.log("Input element not found, trying to focus component container.");
          cascaderRef.value.$el.focus();
        }
      }
    };
    //支持类型
    watch(() => storeData1.StoreLocationConditionRO[8].condition, newCondition => {
      const allOptions = storeData1.storeLocationConditionList.supportType;
      if (allOptions.length === 0) {
        storeData1.StoreLocationConditionCheck.supportType = true;
      } else if (newCondition.length === allOptions.length) {
        const allSelected = allOptions.every(option => newCondition.includes(option));
        storeData1.StoreLocationConditionCheck.supportType = allSelected;
      } else {
        storeData1.StoreLocationConditionCheck.supportType = false;
      }
      if (newCondition.length > 0 && newCondition.length < allOptions.length) {
        storeData1.StoreLocationConditionCheck.supportTypeIndeterminate = true;
      } else {
        storeData1.StoreLocationConditionCheck.supportTypeIndeterminate = false;
      }
    }, {
      deep: true
    });
    const onCheckAllChange1SupportType = e => {
      const checked = e.target.checked;
      storeData1.StoreLocationConditionCheck.supportType = checked;
      storeData1.StoreLocationConditionCheck.supportTypeIndeterminate = false;
      const selectedArray = storeData1.StoreLocationConditionRO[8].condition;
      const allOptions = storeData1.storeLocationConditionList.supportType;
      if (checked) {
        storeData1.StoreLocationConditionRO[8].condition = [...allOptions];
      } else {
        storeData1.StoreLocationConditionRO[8].condition = [];
      }
    };
    //AEC
    watch(() => storeData1.StoreLocationConditionRO[0].condition, newCondition => {
      const allOptions = storeData1.storeLocationConditionList.aec;
      if (allOptions.length === 0) {
        storeData1.StoreLocationConditionCheck.aec = true;
      } else if (newCondition.length === allOptions.length) {
        const allSelected = allOptions.every(option => newCondition.includes(option));
        storeData1.StoreLocationConditionCheck.aec = allSelected;
      } else {
        storeData1.StoreLocationConditionCheck.aec = false;
      }
      if (newCondition.length > 0 && newCondition.length < allOptions.length) {
        storeData1.StoreLocationConditionCheck.aecIndeterminate = true;
      } else {
        storeData1.StoreLocationConditionCheck.aecIndeterminate = false;
      }
    }, {
      deep: true
    });
    const onCheckAllChange1Aec = e => {
      const checked = e.target.checked;
      storeData1.StoreLocationConditionCheck.aec = checked;
      storeData1.StoreLocationConditionCheck.aecIndeterminate = false;
      const selectedArray = storeData1.StoreLocationConditionRO[0].condition;
      const allOptions = storeData1.storeLocationConditionList.aec;
      if (checked) {
        storeData1.StoreLocationConditionRO[0].condition = [...allOptions];
      } else {
        storeData1.StoreLocationConditionRO[0].condition = [];
      }
    };
    //gender
    watch(() => storeData1.StoreLocationConditionRO[4].condition, newCondition => {
      const allOptions = storeData1.storeLocationConditionList.gender;
      if (allOptions.length === 0) {
        storeData1.StoreLocationConditionCheck.gender = true;
      } else if (newCondition.length === allOptions.length) {
        const allSelected = allOptions.every(option => newCondition.includes(option));
        storeData1.StoreLocationConditionCheck.gender = allSelected;
      } else {
        storeData1.StoreLocationConditionCheck.gender = false;
      }
      if (newCondition.length > 0 && newCondition.length < allOptions.length) {
        storeData1.StoreLocationConditionCheck.genderIndeterminate = true;
      } else {
        storeData1.StoreLocationConditionCheck.genderIndeterminate = false;
      }
    }, {
      deep: true
    });
    const onCheckAllChange1Gender = e => {
      const checked = e.target.checked;
      storeData1.StoreLocationConditionCheck.gender = checked;
      storeData1.StoreLocationConditionCheck.genderIndeterminate = false;
      const selectedArray = storeData1.StoreLocationConditionRO[4].condition;
      const allOptions = storeData1.storeLocationConditionList.gender;
      if (checked) {
        storeData1.StoreLocationConditionRO[4].condition = [...allOptions];
      } else {
        storeData1.StoreLocationConditionRO[4].condition = [];
      }
    };
    //category
    // watch(
    //   () => storeData1.StoreLocationConditionRO[1].condition, 
    //   (newCondition) => {
    //     const allOptions = storeData1.storeLocationConditionList.category;

    //     if (allOptions.length === 0) {
    //       storeData1.StoreLocationConditionCheck.category = true;
    //     } else if (newCondition.length === allOptions.length) {
    //       const allSelected = allOptions.every(option => newCondition.includes(option));
    //       storeData1.StoreLocationConditionCheck.category = allSelected;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.category = false;
    //     }

    //     if (newCondition.length > 0 && newCondition.length < allOptions.length) {
    //       storeData1.StoreLocationConditionCheck.categoryIndeterminate = true;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.categoryIndeterminate = false;
    //     }
    //   },
    //   { deep: true }
    // );
    // const onCheckAllChange1Category = e => {
    //   const checked = e.target.checked;

    //   storeData1.StoreLocationConditionCheck.category = checked;
    //   storeData1.StoreLocationConditionCheck.categoryIndeterminate = false;

    //   const selectedArray = storeData1.StoreLocationConditionRO[1].condition;
    //   const allOptions = storeData1.storeLocationConditionList.category;

    //   if (checked) {
    //     storeData1.StoreLocationConditionRO[1].condition = [...allOptions]; 
    //   } else {
    //     storeData1.StoreLocationConditionRO[1].condition = [];
    //   }
    // };
    //region
    // watch(
    //   () => storeData1.StoreLocationConditionRO[7].condition, 
    //   (newCondition) => {
    //     const allOptions = storeData1.storeLocationConditionList.region;

    //     if (allOptions.length === 0) {
    //       storeData1.StoreLocationConditionCheck.region = true;
    //     } else if (newCondition.length === allOptions.length) {
    //       const allSelected = allOptions.every(option => newCondition.includes(option));
    //       storeData1.StoreLocationConditionCheck.region = allSelected;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.region = false;
    //     }

    //     if (newCondition.length > 0 && newCondition.length < allOptions.length) {
    //       storeData1.StoreLocationConditionCheck.regionIndeterminate = true;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.regionIndeterminate = false;
    //     }
    //   },
    //   { deep: true }
    // );
    // const onCheckAllChange1Region = e => {
    //   const checked = e.target.checked;

    //   storeData1.StoreLocationConditionCheck.region = checked;
    //   storeData1.StoreLocationConditionCheck.regionIndeterminate = false;

    //   const selectedArray = storeData1.StoreLocationConditionRO[1].condition;
    //   const allOptions = storeData1.storeLocationConditionList.region;

    //   if (checked) {
    //     storeData1.StoreLocationConditionRO[7].condition = [...allOptions]; 
    //   } else {
    //     storeData1.StoreLocationConditionRO[7].condition = [];
    //   }
    // };
    //location
    // watch(
    //   () => storeData1.StoreLocationConditionRO[5].condition, 
    //   (newCondition) => {
    //     const allOptions = storeData1.storeLocationConditionList.location;

    //     if (allOptions.length === 0) {
    //       storeData1.StoreLocationConditionCheck.location = true;
    //     } else if (newCondition.length === allOptions.length) {
    //       const allSelected = allOptions.every(option => newCondition.includes(option));
    //       storeData1.StoreLocationConditionCheck.location = allSelected;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.location = false;
    //     }

    //     if (newCondition.length > 0 && newCondition.length < allOptions.length) {
    //       storeData1.StoreLocationConditionCheck.locationIndeterminate = true;
    //     } else {
    //       storeData1.StoreLocationConditionCheck.locationIndeterminate = false;
    //     }
    //   },
    //   { deep: true }
    // );
    // const onCheckAllChange1Location = e => {
    //   const checked = e.target.checked;

    //   storeData1.StoreLocationConditionCheck.location = checked;
    //   storeData1.StoreLocationConditionCheck.locationIndeterminate = false;

    //   const selectedArray = storeData1.StoreLocationConditionRO[5].condition;
    //   const allOptions = storeData1.storeLocationConditionList.location;

    //   if (checked) {
    //     storeData1.StoreLocationConditionRO[5].condition = [...allOptions]; 
    //   } else {
    //     storeData1.StoreLocationConditionRO[5].condition = [];
    //   }
    // };
    //locationSummaryInput
    const filteredLocationSummary = computed(() => {
      const input = storeData1.StoreLocationConditionCheck.locationSummaryInput?.toLowerCase()?.trim() || "";

      // 防止 undefined
      const options = storeData1.storeLocationConditionList.locationSummary || [];
      return options.filter(option => String(option).toLowerCase().includes(input));
    });
    watch(() => [storeData1.StoreLocationConditionRO[6].condition, filteredLocationSummary.value], () => {
      const checkedList = storeData1.StoreLocationConditionRO[6].condition || [];
      const filteredOptions = filteredLocationSummary.value || [];
      const checkedCount = filteredOptions.filter(option => checkedList.includes(option)).length;
      storeData1.StoreLocationConditionCheck.locationSummary = checkedCount === filteredOptions.length && filteredOptions.length > 0;
      storeData1.StoreLocationConditionCheck.locationSummaryIndeterminate = checkedCount > 0 && checkedCount < filteredOptions.length;
    }, {
      deep: true,
      immediate: true
    });
    const onCheckAllChange1LocationSummary = e => {
      const checked = e.target.checked;
      const filteredOptions = filteredLocationSummary.value || [];
      let selectedList = [...(storeData1.StoreLocationConditionRO[6].condition || [])];
      if (checked) {
        filteredOptions.forEach(item => {
          if (!selectedList.includes(item)) {
            selectedList.push(item);
          }
        });
      } else {
        selectedList = selectedList.filter(item => !filteredOptions.includes(item));
      }
      storeData1.StoreLocationConditionRO[6].condition = selectedList;
      storeData1.StoreLocationConditionCheck.locationSummary = checked;
      storeData1.StoreLocationConditionCheck.locationSummaryIndeterminate = false;
    };
    //店铺类型
    const filteredStoreTypeData = computed(() => {
      const keyword = storeData1.StoreLocationConditionCheck.storeTypeNameInput?.toLowerCase()?.trim() || "";
      const list = storeData1.storeTypeData || [];
      return list.filter(item => String(item).toLowerCase().includes(keyword));
    });
    watch(() => [storeData1.StoreLocationConditionRO[3].condition, filteredStoreTypeData.value], () => {
      const checkedList = storeData1.StoreLocationConditionRO[3].condition || [];
      const filteredList = filteredStoreTypeData.value || [];
      const checkedCount = filteredList.filter(item => checkedList.includes(item)).length;
      storeData1.StoreLocationConditionCheck.storeTypeName = filteredList.length > 0 && checkedCount === filteredList.length;
      storeData1.StoreLocationConditionCheck.storeTypeNameIndeterminate = checkedCount > 0 && checkedCount < filteredList.length;
    }, {
      deep: true,
      immediate: true
    });
    const onCheckAllChange1 = e => {
      const checked = e.target.checked;
      const filteredList = filteredStoreTypeData.value || [];
      let selected = storeData1.StoreLocationConditionRO[3].condition || [];
      if (checked) {
        // 只添加当前搜索结果
        filteredList.forEach(item => {
          if (!selected.includes(item)) {
            selected.push(item);
          }
        });
      } else {
        // 只移除当前搜索结果
        selected = selected.filter(item => !filteredList.includes(item));
      }
      storeData1.StoreLocationConditionRO[3].condition = selected;
      storeData1.StoreLocationConditionCheck.storeTypeName = checked;
      storeData1.StoreLocationConditionCheck.storeTypeNameIndeterminate = false;
    };
    /* =======================
    category filter
    ======================= */
    const filteredCategory = computed(() => {
      const keyword = storeData1.StoreLocationConditionCheck.categoryInput?.toLowerCase()?.trim() || "";
      const list = storeData1.storeLocationConditionList.category || [];
      return list.filter(i => String(i).toLowerCase().includes(keyword));
    });
    watch(() => storeData1.StoreLocationConditionRO[1].condition, newCondition => {
      const all = filteredCategory.value || [];
      const checked = newCondition || [];
      const count = all.filter(i => checked.includes(i)).length;
      storeData1.StoreLocationConditionCheck.category = all.length > 0 && count === all.length;
      storeData1.StoreLocationConditionCheck.categoryIndeterminate = count > 0 && count < all.length;
    }, {
      deep: true
    });
    const onCheckAllChange1Category = e => {
      const checked = e.target.checked;
      const all = filteredCategory.value || [];
      let selected = storeData1.StoreLocationConditionRO[1].condition || [];
      if (checked) {
        all.forEach(i => {
          if (!selected.includes(i)) selected.push(i);
        });
      } else {
        selected = selected.filter(i => !all.includes(i));
      }
      storeData1.StoreLocationConditionRO[1].condition = selected;
      storeData1.StoreLocationConditionCheck.category = checked;
      storeData1.StoreLocationConditionCheck.categoryIndeterminate = false;
    };
    /* =======================
      region filter
    ======================= */
    const filteredRegion = computed(() => {
      const keyword = storeData1.StoreLocationConditionCheck.regionInput?.toLowerCase()?.trim() || "";
      const list = storeData1.storeLocationConditionList.region || [];
      return list.filter(i => String(i).toLowerCase().includes(keyword));
    });
    watch(() => storeData1.StoreLocationConditionRO[7].condition, newCondition => {
      const all = filteredRegion.value || [];
      const checked = newCondition || [];
      const count = all.filter(i => checked.includes(i)).length;
      storeData1.StoreLocationConditionCheck.region = all.length > 0 && count === all.length;
      storeData1.StoreLocationConditionCheck.regionIndeterminate = count > 0 && count < all.length;
    }, {
      deep: true
    });
    const onCheckAllChange1Region = e => {
      const checked = e.target.checked;
      const all = filteredRegion.value || [];
      let selected = storeData1.StoreLocationConditionRO[7].condition || [];
      if (checked) {
        all.forEach(i => {
          if (!selected.includes(i)) selected.push(i);
        });
      } else {
        selected = selected.filter(i => !all.includes(i));
      }
      storeData1.StoreLocationConditionRO[7].condition = selected;
      storeData1.StoreLocationConditionCheck.region = checked;
      storeData1.StoreLocationConditionCheck.regionIndeterminate = false;
    };

    /* =======================
      location filter
    ======================= */
    const filteredLocation = computed(() => {
      const keyword = storeData1.StoreLocationConditionCheck.locationInput?.toLowerCase()?.trim() || "";
      const list = storeData1.storeLocationConditionList.location || [];
      return list.filter(i => String(i).toLowerCase().includes(keyword));
    });
    watch(() => storeData1.StoreLocationConditionRO[5].condition, newCondition => {
      const all = filteredLocation.value || [];
      const checked = newCondition || [];
      const count = all.filter(i => checked.includes(i)).length;
      storeData1.StoreLocationConditionCheck.location = all.length > 0 && count === all.length;
      storeData1.StoreLocationConditionCheck.locationIndeterminate = count > 0 && count < all.length;
    }, {
      deep: true
    });
    const onCheckAllChange1Location = e => {
      const checked = e.target.checked;
      const all = filteredLocation.value || [];
      let selected = storeData1.StoreLocationConditionRO[5].condition || [];
      if (checked) {
        all.forEach(i => {
          if (!selected.includes(i)) selected.push(i);
        });
      } else {
        selected = selected.filter(i => !all.includes(i));
      }
      storeData1.StoreLocationConditionRO[5].condition = selected;
      storeData1.StoreLocationConditionCheck.location = checked;
      storeData1.StoreLocationConditionCheck.locationIndeterminate = false;
    };

    //查找
    const queryData = () => {
      console.log(storeData1.StoreLocationConditionRO);
      storeData1.paginationData.currentPage = 1;
      getStoreByPageRequest(1, storeData1.paginationData.pageSize, storeData1.StoreLocationConditionRO);
    };
    return {
      filteredCategory,
      filteredRegion,
      filteredLocation,
      filteredStoreTypeData,
      filteredLocationSummary,
      onCheckAllChange1LocationSummary,
      onCheckAllChange1Location,
      onCheckAllChange1Region,
      onCheckAllChange1Category,
      onCheckAllChange1Gender,
      onCheckAllChange1Aec,
      onCheckAllChange1SupportType,
      queryData,
      onCheckAllChange1,
      cascaderRef,
      handleIconClick,
      cityArrChange,
      handleScroll1,
      checkScrollBottom1,
      permission,
      storeLoading1,
      storeForm1,
      storeData1,
      headerCellClickEvent1,
      storeTable1,
      openuploadStore1Location1Popover1,
      uploadStore1Location1,
      uploadStore1Location1PopoverVisible,
      uploadStore1Location1Data,
      handleStoreLocationExceed1,
      handleStoreLocationBeforeUpload1,
      handleStoreLocationOnSuccess1,
      openuploadStore1Popover1,
      uploadStore1,
      uploadStore1PopoverVisible,
      uploadStore1Data1,
      handleStoreExceed1,
      handleStoreBeforeUpload1,
      handleStoreOnSuccess1,
      searchStoreClick1,
      cancelSaveStore1,
      storeUpdateClick1,
      storeDeleteClick1,
      goLocation1,
      storeTypeNum1,
      activityIdNum1,
      activityData1,
      storeClickEvent1,
      locale,
      uploadFilePopoverVisible,
      openUploadFilePopover,
      handleFileBeforeUpload,
      handleFileOnSuccess,
      uploadFileData,
      uploadFile,
      handleTableChange,
      getAllStoreLocationExport,
      arrValue,
      filteredStoreTypeData,
      columns: columns,
      // 使用响应式的 columns,
      tableBoxRef,
      // 暴露给模板
      tableScrollY,
      // 暴露给模板
      calcTableHeight // 如果其他地方需要手动触发重算也可以暴露
    };
  }
});